<template>
  <a-row :gutter="16">
    <a-col :xxl="6" :xl="8" :lg="8" :md="12">
      <a-input-group compact>
        <a-select v-model:value="queryForm.datetype" :options="datetypes" :filter-option="$filters.filterOption"
          show-search style="width:30%;" />
        <a-range-picker v-model:value="queryForm.daterange" :ranges="ranges" :locale="locale" value-format="YYYY-MM-DD"
          style="width:70%;" />
      </a-input-group>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;" />
    </a-col>
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-input v-model:value="queryForm.name" placeholder="店铺名称" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="getData">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="link" @click="getData">刷新数据</a-button>
    </a-space>
    <a-space>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="exportall">导出</a-menu-item>
            <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
          </a-menu>
        </template>
        <a-button type="primary">
          导出数据
          <DownOutlined />
        </a-button>
      </a-dropdown>
    </a-space>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="false">
    <template #bodyCell="{ index, record, column }">
      <template v-if="column.dataIndex === 'index'">
        {{ index + 1 }}
      </template>
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'platform'">
        {{ getplatform(record.platform) }}
      </template>
      <template v-if="column.dataIndex === 'count'">
        {{ record.count }}
        <a-button v-if="record.isRoot && !record.shop_statistics_status" type="link"
          @click="refresh(record._id)">刷新</a-button>
      </template>
      <template v-if="column.dataIndex === 'idcard'">
        <a-image v-if="record.idcard1" :width="100" :src="record.idcard1" />
        <a-image v-if="record.idcard2" :width="100" :src="record.idcard2" />
      </template>
      <template v-if="column.dataIndex === 'businesslicense'">
        <a-image v-if="record.businesslicense" :width="100" :src="record.businesslicense" />
      </template>
      <template v-if="column.dataIndex === 'state'">
        <a-tag v-if="record.state === -1" color="processing">未授权</a-tag>
        <a-tag v-if="record.state === 0" color="success">授权成功</a-tag>
        <a-tag v-if="record.state === 1" color="error">授权异常</a-tag>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a href="javascript:;" class="underline" @click="edit(record)">
          完善信息
        </a>
      </template>
    </template>
    <template #summary>
      <a-table-summary fixed="top">
        <a-table-summary-row>
          <a-table-summary-cell :index="0" :col-span="6">
            <p class="text-error text-h6 text-center">
              合计
            </p>
          </a-table-summary-cell>
          <a-table-summary-cell :index="6">
            <p class="text-success text-h6 text-center">
              {{ $filters.formatMoney(total.count, 0, '') }}
            </p>
          </a-table-summary-cell>
          <a-table-summary-cell :index="7">
            <p class="text-success text-h6 text-center">
              {{ $filters.formatMoney(total.amount, 2, '') }}
            </p>
          </a-table-summary-cell>
          <a-table-summary-cell :index="8">
            <p class="text-error text-h6 text-center">
              {{ $filters.formatMoney(total.dcount, 0, '') }}
            </p>
          </a-table-summary-cell>
          <a-table-summary-cell :index="9">
            <p class="text-error text-h6 text-center">
              {{ $filters.formatMoney(total.damount, 2, '') }}
            </p>
          </a-table-summary-cell>
          <a-table-summary-cell :index="10"></a-table-summary-cell>
          <a-table-summary-cell :index="11"></a-table-summary-cell>
          <a-table-summary-cell :index="12"></a-table-summary-cell>
          <a-table-summary-cell :index="13"></a-table-summary-cell>
          <a-table-summary-cell :index="14"></a-table-summary-cell>
          <a-table-summary-cell :index="15"></a-table-summary-cell>
        </a-table-summary-row>
      </a-table-summary>
    </template>
  </a-table>
  <a-modal v-model:visible="editModal" title="完善信息" @ok="save" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
    :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving"
    width="500px">
    <a-form ref="editFormRef" name="editForm" :model="editForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="法人姓名" name="legalperson" :rules="[{ required: true, message: '请输入法人姓名' }]">
            <a-input v-model:value="editForm.legalperson" placeholder="法人姓名" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="身份证(头像页)" name="idcard1">
            <a-upload v-model:file-list="idcard1" accept="image/jpg,image/jpeg,image/png" list-type="picture-card"
              :before-upload="beforeUpload" :customRequest="(e) => uploadFile(e, 'idcard1')"
              @remove="(file) => handleRemove(file, 'idcard1')" @preview="handlePreview" :disabled="uploading">
              <div v-if="idcard1.length < 1">
                <loading-outlined v-if="uploading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传证件</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="身份证(国徽页)" name="idcard2">
            <a-upload v-model:file-list="idcard2" accept="image/jpg,image/jpeg,image/png" list-type="picture-card"
              :before-upload="beforeUpload" :customRequest="(e) => uploadFile(e, 'idcard2')"
              @remove="(file) => handleRemove(file, 'idcard2')" @preview="handlePreview" :disabled="uploading">
              <div v-if="idcard2.length < 1">
                <loading-outlined v-if="uploading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传证件</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="营业执照" name="businesslicense">
            <a-upload v-model:file-list="businesslicense" accept="image/jpg,image/jpeg,image/png"
              list-type="picture-card" :before-upload="beforeUpload"
              :customRequest="(e) => uploadFile(e, 'businesslicense')"
              @remove="(file) => handleRemove(file, 'businesslicense')" @preview="handlePreview" :disabled="uploading">
              <div v-if="businesslicense.length < 1">
                <loading-outlined v-if="uploading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传证件</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <a-modal v-model:visible="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
  <Download ref="downloadRef" />
</template>
<script setup>
import dayjs from 'dayjs';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { DownOutlined, LoadingOutlined, PlusOutlined, } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import Download from "@/components/download.vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const { proxy } = getCurrentInstance();

const columns = [
  { title: "序号", dataIndex: "index", width: 100, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },
  { title: "所属商户", dataIndex: "org", width: 100, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },
  { title: "电商平台", dataIndex: "platform", width: 100, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },
  { title: "账号", dataIndex: "account_username", width: 180, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },
  { title: "店铺名称", dataIndex: "shop_name", width: 150 },
  { title: "店铺ID", dataIndex: "client_id", width: 120 },
  { title: "订单数量", dataIndex: "count", align: "center", width: 150 },
  { title: "订单金额", dataIndex: "amount", align: "center", width: 200 },
  { title: "退单数量", dataIndex: "dcount", align: "center", width: 150 },
  { title: "退款金额", dataIndex: "damount", align: "center", width: 200 },
  { title: "法人姓名", dataIndex: "legalperson", width: 100, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },//姓名
  { title: "身份证", dataIndex: "idcard", width: 100, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },//法人身份证正反面照片
  { title: "营业执照", dataIndex: "businesslicense", width: 100, customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },//营业执照照片
  { title: "状态", dataIndex: "state", width: 100 },
  { title: "授权时间", dataIndex: "auth_time", width: 160 },
  { title: "操作", dataIndex: "operation", width: 100, fixed: "right", customCell: (record, rowIndex, column) => ({ rowSpan: record.rowSpan || 0 }), },
];
const downloadRef = ref();
const datetypes = ref([
  { value: 2, label: "发货时间" },
  { value: 1, label: "付款时间" },
]);
const ranges = ref({
  '近一周': [dayjs().subtract(7, 'day'), dayjs()],
  '近一月': [dayjs().subtract(1, 'month'), dayjs()],
  '近三月': [dayjs().subtract(3, 'month'), dayjs()],
  '近六月': [dayjs().subtract(6, 'month'), dayjs()],
});
const queryForm = ref({
  datetype: 2,
  daterange: ["", ""],
  orgid: "ALL",
  name: "",
});
const dataLoading = ref(false);
const data = ref([]);
const orgs = ref([]);
const editForm = ref({});
const editModal = ref(false);
const editFormRef = ref();
const saving = ref(false);
const uploading = ref(false);
const idcard1 = ref([]);
const idcard2 = ref([]);
const businesslicense = ref([]);
const previewVisible = ref(false);
const previewImage = ref("");

const width = computed(() => proxy.$utils.twidth(columns));
const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const total = computed(() => {
  let total = {
    count: 0,
    amount: proxy.$d(),
    dcount: 0,
    damount: proxy.$d(),
  };
  for (let i = 0; i < data.value.length; i++) {
    let {
      count,
      amount,
      dcount,
      damount,
    } = data.value[i];
    total.count += count;
    total.amount = total.amount.plus(amount);
    total.dcount += dcount;
    total.damount = total.damount.plus(damount);
  }
  return total;
})

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result));
    reader.addEventListener('error', (error) => reject());
    reader.readAsDataURL(file);
  });
}

onMounted(() => {
  getData();
});
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/erpshop/list", { ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, "YYYY-MM-DD HH:mm:ss"),
        };
      });
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const refresh = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/erpshop/refresh", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
//完善店铺信息，法人信息，营业执照
const edit = (item) => {
  console.log("edit");
  editForm.value = {
    orgid: item.orgid,
    platform: item.platform,
    account_username: item.account_username,
    legalperson: item.legalperson,
    idcard1: item.idcard1,
    idcard2: item.idcard2,
    businesslicense: item.businesslicense
  };
  idcard1.value = item.idcard1 ? [{ url: item.idcard1, status: "done" }] : [];
  idcard2.value = item.idcard2 ? [{ url: item.idcard2, status: "done" }] : [];
  businesslicense.value = item.businesslicense ? [{ url: item.businesslicense, status: "done" }] : [];
  editModal.value = true;
};
const save = async () => {
  try {
    await editFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/erpshop/edit", { dataForm: editForm.value, }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        message.success("保存成功");
        editModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
}
const cancelSave = () => {
  console.log('cancelSave');
  editFormRef.value.clearValidate();
}
const handleCancel = () => {
  previewVisible.value = false;
}
const handlePreview = async (file) => {
  console.log('handlePreview', file);
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj);
  }
  console.log(file);
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
}
const handleRemove = (file, key) => {
  console.log("handleRemove", file);
  if (key === 'idcard1') {
    let newFileList = idcard1.value.slice();
    idcard1.value = _.filter(newFileList, (n) => n.url !== file.url);
    editForm.value.idcard1 = "";
  }
  else if (key === 'idcard2') {
    let newFileList = idcard2.value.slice();
    idcard2.value = _.filter(newFileList, (n) => n.url !== file.url);
    editForm.value.idcard2 = "";
  }
  else if (key === 'businesslicense') {
    let newFileList = businesslicense.value.slice();
    businesslicense.value = _.filter(newFileList, (n) => n.url !== file.url);
    editForm.value.businesslicense = "";
  }
}
const beforeUpload = file => {
  const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('只能上传JPG/PNG图片!');
  }
  const isLtSize = file.size / 1024 / 1024 <= 10;
  if (!isLtSize) {
    message.error('图片不能大于10MB!');
  }
  return isJpgOrPng && isLtSize;
}
const uploadFile = async (e, key) => {
  uploading.value = true;
  let file = e.file;
  const slicefiles = proxy.$utils.sliceFile(file.size);
  const faid = proxy.$utils.uuid();
  for (let j = 0; j < slicefiles.length; j++) {
    let slicefile = slicefiles[j];
    const formData = new FormData();
    if (slicefile.chunks > 1) {
      let _file = file.slice(slicefile.from, slicefile.to);
      formData.set("file", _file);
    } else {
      formData.set("file", file);
    }
    formData.set("faid", faid);
    formData.set("chunk", slicefile.chunk);
    formData.set("chunks", slicefile.chunks);
    formData.set("originalname", file.name);
    formData.set("key", key);
    try {
      let res = await proxy.$api.doUpload("/erpshop/plupload", formData);
      if (res.code === 0) {
        if (slicefile.chunk + 1 === slicefile.chunks) {
          file.status = "done";
          file.url = res.data.url;
          if (key === "idcard1") {
            editForm.value.idcard1 = res.data.url;
            idcard1.value.forEach(n => {
              if (n.uid === file.uid) {
                n.status = "done";
                n.url = res.data.url;
              }
            });
          }
          else if (key === "idcard2") {
            editForm.value.idcard2 = res.data.url;
            idcard2.value.forEach(n => {
              if (n.uid === file.uid) {
                n.status = "done";
                n.url = res.data.url;
              }
            });
          }
          else if (key === "businesslicense") {
            editForm.value.businesslicense = res.data.url;
            businesslicense.value.forEach(n => {
              if (n.uid === file.uid) {
                n.status = "done";
                n.url = res.data.url;
              }
            });
          }
        }
      } else {
        message.error(res.msg);
        if (key === "idcard1") {
          idcard1.value.forEach(n => {
            if (n.uid === file.uid) {
              n.status = "error";
            }
          });
        }
        else if (key === "idcard2") {
          idcard2.value.forEach(n => {
            if (n.uid === file.uid) {
              n.status = "error";
            }
          });
        }
        else if (key === "businesslicense") {
          businesslicense.value.forEach(n => {
            if (n.uid === file.uid) {
              n.status = "error";
            }
          });
        }
        break;
      }
    } catch (e) {
      console.error(e);
      message.error(e.message);
      break;
    }
  }
  uploading.value = false;
}
const exportdata = (ids) => {
  return new Promise(resolve => {
    dataLoading.value = true;
    proxy.$api.doAPI("/erpshop/list", { ...queryForm.value, ids, action: "download" }).then((res) => {
      dataLoading.value = false;
      resolve(true);
    }).catch((err) => {
      dataLoading.value = false;
      resolve(false);
      console.error(err);
    });
  })
}
const exportall = () => {
  exportdata([]).then((ok) => { if (ok) exporttask() });
}
const exporttask = () => {
  downloadRef.value.showDownload({ title: "导出店铺明细", type: "erpshop" });
}
const getplatform = (platform) => {
  return _.findWhere(proxy.$constant.platforms, { value: platform })?.label || platform;
}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

:deep(.ant-table-tbody > tr > td) {
  padding: 8px 8px !important;
}

:deep(.ant-table-summary > tr > td) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>